export const facetSearchInputNameId = 'facet-search-input';
export const gridItemsPerPage = 30;
export const listItemsPerPage = 24;
